<template>
	<main class="block-main main" :class="device_platform" :style="getStyle">
		<div class="main__swiper swiper-container">
			<div class="main__swiper-wrapper swiper-wrapper">
				<div
					class="main__swiper-slide swiper-slide"
					v-for="(swiper, i) in swipers"
					:key="i"
				>
					<div
						class="main__content"
					>
						<div class="main__container container">
              <div class="main__info">
                <h2 class="main__title title" v-html="swiper.title"></h2>
                <p
                  class="main__subtitle"
                  :class="{ 'main__subtitle--yellow': swiper.yellow }"
                  v-html="swiper.subtitle"
                ></p>
                <ul v-if="swiper.advs" class="main__advs">
                  <li
                      v-for="(adv, i) of swiper.advs" :key="i"
                      class="main__advs-item"
                      v-html="adv"
                  ></li>
                </ul>
                <p v-if="swiper.text" class="main__text" v-html="swiper.text"></p>
                <button
                  v-if="swiper.id != 4"
                  class="main__btn button button_theme_primary"
                  @click="
                    getCall({
                      type: 'sale',
                      form: 'main',
                      title: 'Получить предложение',
                    })
                  "
                >
                  <span>{{ swiper.btnText }}</span>
                </button>
              </div>

              <img :src="getImg(swipers[0].img)" alt="" class="main__img">
						</div>
					</div>
				</div>
			</div>
		</div>

    <div class="main__mobile">
      <p
          class="main__subtitle main__subtitle--mobile"
          v-html="swipers[0].subtitle"
      ></p>

      <ul v-if="swipers[0].advs" class="main__advs main__advs--mobile">
        <li
            v-for="(adv, i) of swipers[0].advs" :key="i"
            class="main__advs-item"
            v-html="adv"
        ></li>
      </ul>
    </div>
	</main>
</template>

<script>
	import Mixin from "../common/mixin";
	import finance from "../common/finance";
	import Swiper from "swiper";

	export default {
		name: "block-main",
		mixins: [Mixin, finance],
		data() {
			return {
				swipers: [
          {
            id: 0,
            title: 'Современный фитнес-клуб',
            subtitle: '1 минута от м. Фрунзенская',
            advs: [
                'бесплатное гостевое посещение',
                'оплата по месяцам',
                'спецпредложения для студентов',
            ],
            text: 'Оставьте заявку на бесплатный гостевой визит',
            btnText: 'Оставить заявку',
            img: 'main0.jpg',
          },
					// {
					// 	id: 0,
					// 	title: "Безлимитный фитнес от 2500₽",
					// 	subtitle:
					// 		"Оставь заявку сейчас и получи доступ на бесплатное гостевое посещение",
					// 	btnText: "Получить предложение",
					// },
					// {
					// 	id: 4,
					// 	title: "Приглашаем на практический семинар",
					// 	subtitle: "красивые ягодицы через осанку",
					// 	text: '<span class="large">7 августа <b>20:00</b></span><br/>студия сайкла',
					// 	second_text:
					// 		"Предварительная регистрация обязятальна.<br/>Подробности уточняйте у специалистов отдела продаж",
					// },
					// {
					// 	id: 1,
					// 	title: "",
					// 	subtitle:
					// 		"Начните заниматься сейчас, а абонемент оплачивайте частями",
					// 	btnText: "Узнать подробности",
					// },
					// {
					// 	id: 2,
					// 	title: "Занимайтесь фитнесом вместе с друзьями!",
					// 	subtitle:
					// 		"При покупке абонемента в этом месяце, <br> дарим Вашему другу 1 месяц бесплатных занятий",
					// 	btnText: "Оставить заявку",
					// },
					// {
					// 	id: 3,
					// 	yellow: true,
					// 	title: "Специальные цены",
					// 	subtitle: "Для студентов",
					// 	text: "Позвони сейчас и получи персональное предложение",
					// 	btnText: "Оставить заявку",
					// },
					
				],
        headerHeight: '0px',
			};
		},
		mounted() {
			// this.initSwiper();  // отключил, так как с одним слайдом всё равно листается
      // this.getHeaderHeight()
      this.$nextTick(() => {
        this.getHeaderHeight()
      });
      window.addEventListener('resize', this.getHeaderHeight)
		},
		methods: {
			initSwiper() {
				this.swiper = new Swiper(".main__swiper", {
					autoplay: {
						delay: 4000,
					},
				});
			},
      getHeaderHeight() {
        this.headerHeight = document.getElementById('header')
            .scrollHeight + 'px'
      },
      getImg(img) {
        return require(`../images/bg/${img}`)
      },
		},
    computed: {
      getStyle() {
        return `margin-top: ${this.headerHeight};`
      }
    },
	};
</script>

<style scoped lang="scss">
	@import "../styles/constants.scss";

	.main {
		position: relative;
		z-index: 10;

		&__swiper {
			width: 100%;
			//height: calc(800 / 1920 * 100vw);
		}

		&__swiper-slide {
      color: #ffffff;
      //background-color: #000000;
		}

		&__content {
			width: 100%;
			padding-bottom: 40px;

			&--small {
				width: 40%;
			}
		}

    &__container {
      height: 500px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 30px;
    }

		&__super-title {
			font-family: "Bebas Neue", sans-serif;
			font-size: 80px;
			margin-top: 0.8em;
		}

		&__title {
			font-size: 65px;
      color: inherit;
			margin-bottom: 7px;

			._4 & {
				font-size: 2vw;
				color: $primary;
				text-transform: uppercase;
				margin-bottom: 10px;
			}

			._0 & {
				color: $primary;
			}
		}

		&__subtitle {
			font-size: 40px;
      margin-top: 1em;
			margin-bottom: 40px;

			._1 & {
				font-weight: bold;
				text-transform: uppercase;
				color: #000000;
			}

			._4 & {
				font-size: 3.5vw;
				text-transform: uppercase;
				letter-spacing: 2px;
				font-weight: 700;
			}

			&--yellow {
				font-family: "Bebas Neue", sans-serif;
				font-size: 4.2vw;
				font-weight: bold;
				color: $primary;
				margin: 0;
			}
		}

    &__advs {
      font-size: 20px;
      padding-left: 1.3em;
    }

		&__text {
			font-size: 16px;
			margin-top: 1em;
			margin-bottom: 1.3em;

			._4 & {
				font-size: 2.2vw;
				text-transform: uppercase;
				letter-spacing: 2px;
				font-weight: 700;
				margin-bottom: 4vw;

				&-second {
					font-size: 1.2vw;
					font-weight: 300;
					text-transform: none;
					border-left: 5px solid $primary;
					padding-left: 20px;
					margin-bottom: 60px;
				}

				.large {
					font-size: 40px;
				}
			}
		}

		&__btn {
			max-width: 309px;
		}

    &__img {
      position: absolute;
      left: 0;
      top: 0;
      z-index: -1;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: right center;
    }

    &__mobile {
      display: none;
    }
	}

  @media (max-width: 1920px) {
    .main {
      &__super-title {
        font-size: 7vw;
      }

      &__title {
        font-size: 3.5vw;

        ._4 & {
          font-size: 2vw;
        }
      }

      &__subtitle {
        font-size: 2.2vw;

        ._4 & {
          font-size: 3.5vw;
        }

        &--yellow {
          font-size: 4.2vw;
        }
      }

      &__text {

        ._4 & {
          font-size: 2.2vw;

          &-second {
            font-size: 1.2vw;
          }

          .large {
            font-size: 3vw;
          }
        }
      }
    }
  }

	@media (max-width: 1440px) {
		.main {
			&__super-title {
				font-size: 6vw;
				margin-top: 1.3em;
			}

			&__title {
        font-size: 45px;
				margin-top: 1em;

				&--no-margin-top {
					margin-top: 0;
				}
			}

			&__subtitle {
        font-size: 30px;
        margin-bottom: 1em;

				._4 & {
					margin-bottom: 10px;
				}
			}

			&__swiper {
				//height: calc(100vw * 715 / 1440);
			}
		}
	}

	@media (max-width: 1000px) {
		.main {
			&__title {
        font-size: calcFontSize(27, 45, 640, 1000);
				//margin-top: 3em;

				&--no-margin-top {
					margin-top: 0;
				}

				._4 & {
					margin-top: 0px;
				}
			}
			&__subtitle {
        font-size: calcFontSize(20, 30, 640, 1000);

        &--less-margin {
					margin-bottom: 0.3em;
				}
			}

      &__advs {
        font-size: calcFontSize(16, 20, 640, 1000);
      }

			&__text {
        font-size: calcFontSize(14, 16, 640, 1000);

				._4 & {
					margin-bottom: 20px;
				}
			}

      &__btn {
        font-size: calcFontSize(16, 22, 640, 1000);
      }
		}
	}

	@media (max-width: 800px) {
		.main {
			&__swiper {
				height: 540px;
			}

			&__swiper-slide {
				background-position: 80% bottom;
			}

			&__swiper-slide {
			
			&._4 {
				//background: url("../images/bg/main4.jpg") no-repeat right / cover;
			}
		}

			&__text {
				//font-size: 3vw;
			}

			._4 .container {
				padding-top: 80px;
			}

			&__title {
				._4 & {
          max-width: 65%;
					font-size: 6vw;
				}
			}

			&__subtitle {
				._4 & {
					font-size: 7vw;
					max-width: 80%;
				}
			}

			&__text {
				._4 & {
					font-size: 5vw;
					max-width: 80%;

					&-second {
						font-size: 12px;
						max-width: 100%;
						margin-bottom: 0px;
						margin-top: auto;
					}
				}
			}

			&__content--small {
				width: 60%;
				.main__subtitle {
					font-size: 18px;
					background-color: hsla(40, 100%, 50%, 0.7);
					padding: 1em;
				}

				.main__btn {
					max-width: none;
				}
			}
		}
	}

	@media (max-width: 450px) {
		.main {
      &__mobile {
        display: block;
        color: #ffffff;
        //background-color: #000;
        background-image: linear-gradient(#000, #000, #fff);
        padding: 20px 20px 70px;
      }

      &__swiper {
				//height: calc(1000 / 800 * 100vw);
				height: calc(1000 / 1200 * 100vw);

				._3 {
					background-position: 75% 50%;
				}
			}

			&__content {
				padding-top: 0;
				padding-bottom: 0px;
				height: 100%;

				&--small {
					width: 100%;

					.main__subtitle {
						max-width: none;
						background-color: hsla(40, 100%, 50%, 0.8);
						text-shadow: none;
					}
				}
			}

			.container {
				height: 100%;
				//display: flex;
				//flex-direction: column;
				//justify-content: flex-end;
				//text-shadow: 1px 1px 2px #000;
        align-items: stretch;
        position: relative;
			}

      &__info {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        color: #ffffff;
        padding: 20px 10px 5px;
      }

			._4 .container {
				padding-top: 60px;
			}

			&__title {
				font-size: calcFontSize(27, 30, 320, 640);
				//max-width: 65%;
				line-height: 1;
        color: $primary;
        text-align: center;
        margin-top: 0.3em;

				._4 & {
					font-size: 6vw;
				}
			}

			&__subtitle {
        display: none;
				font-size: 4.5vw;
				//max-width: 60%;
        text-align: center;
				margin-bottom: 19px;

				&--yellow {
					font-size: 9vw;
					margin-bottom: 0.1em;
				}

				._4 & {
					font-size: 7vw;
					max-width: 80%;
				}

        &--mobile {
          display: block;
          font-size: 20px;
          font-weight: bold;
          text-align: center;
          margin-top: 0;
        }
			}

      &__advs {
        display: none;

        &--mobile {
          display: block;
          font-size: 14px;
        }
      }

			&__text {
				font-size: 4vw;
        text-shadow: 1px 1px 2px #000;
        text-align: center;
        margin-top: auto;

				._4 & {
					font-size: 5vw;

					&-second {
						font-size: 12px;
					}
				}
			}

			&__btn {
				max-width: none;
        width: 100%;
				height: 42px;
				font-size: 16px;
			}

      &__img {
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        width: 100%;
        max-width: none;
        height: 101%;
        max-height: none;
      }
		}
	}
</style>
<style lang="scss">
	@import "../styles/constants.scss";
	.main {
		&__text {
			._4 & {
				.large {
					font-size: 3.5vw;
				}

				b {
					color: $primary;
				}
			}
		}
	}

	@media (max-width: 450px) {
		.main {
			&__text {
				._4 & {
					.large {
						font-size: 6vw;
					}
				}
			}
		}
	}
</style>
